export const ARTICLE_LIST_OPTIONS_VALUE = {
  PUBLISH: "PUBLISH",
  HIDDEN: "HIDDEN",
  DELETE: "DELETE",
};

export const ARTICLE_LIST_OPTIONS = [
  {
    title: "articles.publishSelectedArticles",
    value: ARTICLE_LIST_OPTIONS_VALUE.PUBLISH,
  },
  {
    title: "articles.hideSelectedArticles",
    value: ARTICLE_LIST_OPTIONS_VALUE.HIDDEN,
  },
  {
    title: "articles.deleteSelectedArticles",
    value: ARTICLE_LIST_OPTIONS_VALUE.DELETE,
  },
];
